'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringFormatter = require('../utils/stringFormatter');

var msPattern = /^ms-/;

exports.default = function (string) {
  return (0, _stringFormatter.hyphenate)(string).replace(msPattern, '-ms-');
};